import { Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { DrilldownContainerChartSize } from '@models';

@Component({
  selector: 'drilldown-chart-container',
  templateUrl: './drilldown-chart-container.component.html',
  styleUrl: './drilldown-chart-container.component.scss'
})
export class DrilldownChartContainerComponent {
  @Input() title!: string | undefined;
  @Input() infoText?: string;
  @Input() size!: DrilldownContainerChartSize;
  @Input() isLoading!: boolean | undefined;
  @Input() showInfoTooltip = true;
  @Input() showEnlargeButton = true;
  @Output() expandChartClicked = new EventEmitter<void>();
  @ContentChild('chart-element', { static: false }) chartElement!: ElementRef;

  infoTooltipOpen = false;

  onExpandChartClicked() {
    this.expandChartClicked.emit();
  }

  getSkeletonHeaderHeight(): string {
    switch (this.size) {
      case 'small':
        return '16px';
      case 'medium':
        return '20px';
    }
  }

  getSkeletonBodyHeight(): string {
    switch (this.size) {
      case 'small':
        return '100px';
      case 'medium':
        return 'calc(100% - 16px)';
    }
  }
}
